"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.validateSelectAccountOptions = void 0;
var joi_1 = __importDefault(require("joi"));
var onboard_common_1 = require("@sovryn/onboard-common");
var basePath = joi_1["default"].object({
    label: joi_1["default"].string().required(),
    value: joi_1["default"].string().required()
});
var basePaths = joi_1["default"].array().items(basePath);
var chains = joi_1["default"].array().items(onboard_common_1.chainValidation);
var asset = joi_1["default"].object({
    label: joi_1["default"].string().required(),
    address: joi_1["default"].string()
});
var assets = joi_1["default"].array().items(asset);
var selectAccountOptions = joi_1["default"].object({
    basePaths: basePaths,
    assets: assets,
    chains: chains,
    scanAccounts: joi_1["default"]["function"]().arity(1).required(),
    supportsCustomPath: joi_1["default"].bool()
});
var validateSelectAccountOptions = function (data) {
    return (0, onboard_common_1.validate)(selectAccountOptions, data);
};
exports.validateSelectAccountOptions = validateSelectAccountOptions;
